<template>
  <lk-card class='promotionCon'>
    <div>
      <lk-form ref="PromotionInfo" :label-width="94" :model='info' :rules='salePromotionInfo'>
        <lk-row v-for="(item, index) in info.promoteDiscountVOList" :key="index">
          <div v-if="!item.remark">
            <lk-col span='13'>
              <lk-form-item :label="index===0 ? '折扣金额:' : '' ">
                <span class="promotionFirstItem">{{item.name}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='10'>
              <lk-form-item>
                <span class="promotionItem">{{`${item.cutPrice}元`}}</span>
              </lk-form-item>
            </lk-col>
          </div>
        </lk-row>
        <lk-row v-if='isNeedInput'>
          <lk-col span='13'>
            <lk-form-item :label="isShowTitle">
              <span class="promotionFirstItem">其他折扣金额</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
             <lk-form-item prop='promotionDiscount'>
              <numberInput
                size='default'
                :ifNeedCheckNum="true"
                :frontDecimal='6'
                :precision ='2'
                :min='0'
                :max='maxDiscount'
                v-model="info.promotionDiscount"
                placeholder="请输入"
              ></numberInput>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row v-if="info.promotionDiscount && isNeedInput">
          <lk-col span='13'>
            <lk-form-item>
              <span class="promotionReason">折扣原因</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
             <lk-form-item prop="promotionReason">
              <lk-input :maxlength='50' placeholder='请输入' v-model.trim="info.promotionReason"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
    </div>
  </lk-card>
  <!-- </div> -->
</template>
<script>
import numberInput from './NumberInput.vue';
import storeUtil from '../../libs/storeUtil';

export default {
  name: 'salesPrimotion',
  components: {
    numberInput
  },
  props: {
    orderInfo: {
      type: Object,
    },
    maxDiscount: {
      type: Number,
    },
    storeId: {
      type: Number,
    },
  },
  model: {
    prop: 'promotionData',
    event: 'change',
  },
  watch: {
    orderInfo: {
      handler() {
        if (this.orderInfo.promoteDiscountVOList && this.orderInfo.promoteDiscountVOList.length) {
          this.info.promoteDiscountVOList = [];
          this.orderInfo.promoteDiscountVOList.forEach((item, index) => {
            if (item.remark) {
              this.$set(this.info, 'promotionDiscount', item.cutPrice);
              this.$set(this.info, 'promotionReason', item.remark);
            } else {
              this.info.promoteDiscountVOList.push(item);
            }
          })
        } else {
          this.info = {
            promoteDiscountVOList: [],
          };
        }
      },
      deep: true,
    },
    'info.promotionDiscount': {
      handler() {
        if (this.info.promotionDiscount) {
          this.setRule();
        } else {
          this.info.promotionReason = '';
        };
        this.$emit('change', this.info);
      }
    }
  },
  computed: {
    isShowTitle() {
      return this.info.promoteDiscountVOList.length ? '' : '折扣金额:';
    },
    isNeedInput() {
      return storeUtil.isNeedSalePromotionInfo(this.storeId);
    },
  },
  data() {
    return {
      info: {
        promoteDiscountVOList: [],
      },
      salePromotionInfo: {},
      storeInfo: [
        {
          id: 7,
          name: '北京临客大药房',
        },
      ],
    };
  },
  methods: {
    setRule() {
      if (this.info.promotionDiscount) {
        this.salePromotionInfo.promotionReason = [{ required: true, message: '请输入折扣原因', trigger: 'blur' }];
      } else {
        this.salePromotionInfo.promotionReason = [{ required: false }];
        this.$nextTick(() => {
          this.$refs.PromotionInfo.validateField('promotionReason', () => {});
        });
      }
    },
    validateForm() {
      this.$emit('change', this.info);
      return new Promise((resolve) => {
        this.isNeedInput ? this.$refs.PromotionInfo.validate((valid) => {
          resolve(valid);
          if (!valid) {
            this.$Message.error('请输入折扣原因');
          }
        }) : resolve(true);
      })
    },
    reset() {
      this.haveRemark = false;
      if (this.orderInfo.promoteDiscountVOList && this.orderInfo.promoteDiscountVOList.length) {
        this.info.promoteDiscountVOList = [];
        this.orderInfo.promoteDiscountVOList.forEach(item => {
          if (item.remark) {
            this.haveRemark = true;
            this.$set(this.info, 'promotionDiscount', item.cutPrice);
            this.$set(this.info, 'promotionReason', item.remark);
          } else {
            this.info.promoteDiscountVOList.push(item);
          }
        })
      } else {
        this.info = {
          promoteDiscountVOList: [],
        };
      }
      if (!this.haveRemark) {
        this.$set(this.info, 'promotionDiscount', null);
        this.$set(this.info, 'promotionReason', null);
      }
    }
  },
  mounted() {
  },
};
</script>
<style lang="less" >
.promotionCon {
  border: none;
  .promotionFirstItem {
    margin-left: 14px;
  }
  .promotionItem {
    margin-left: 90px;
  }
  .promotionReason{
    margin-left: 12px;
    &:before{
      content: '*';
      color: red;
      margin-right: 2px;
    }
  }
}
</style>
